import React, { useContext, useEffect, useState } from "react";
import data from "../data";
import { userDetailsContext } from "../Context";
//components
import OrderTotal from "../components/OrderTotal";
import BuyNow from "../components/BuyNow";
import NoItems from "../components/NoItems";

const Cart = () => {
	const { length, setLength } = useContext(userDetailsContext);
	const [cart, setcart] = useState([]);
	let totalprice = 0;
	useEffect(() => {
		if (localStorage.getItem("cart")) {
			let cartdata = [...JSON.parse(localStorage.getItem("cart"))];
			setLength(cartdata.length);
			setcart(cartdata);
		}
	}, [setLength]);
	function removeItem(id) {
		const newItem = cart.filter((ele) => {
			return id !== ele;
		});
		setcart(newItem);
		setLength(newItem.length);
		localStorage.setItem("cart", JSON.stringify(newItem));
	}
	return (
		<div className='w-full bg-custom-bg py-10 flex flex-col  sm:flex-row justify-around '>
			<section className='flex flex-col sm:w-1/2  bg-white '>
				{!cart.length && <NoItems />}
				{cart.map((element) => {
					let index = data.findIndex((i) => {
						return i.id === parseInt(element);
					});
					const { image, name, price } = data[index];
					totalprice += price;
					// setTotalPrice(totalprice + price);
					return (
						<div className=' flex  justify-start w-full rounded p-5' key={element}>
							<div className='h-full flex justify-center items-center'>
								<img src={image} alt='' width='57' height='112' />
								{/* <div className='flex space-x-1'>
									<button className='p-1 h-6 flex justify-center items-center w-6  border-2 border-gray-600 rounded-full text-center' onClick={() => setCount(count + 1)}>
										+
									</button>
									<input type='text' className='w-10 h-6 border-2 border-gray-500 text-center rounded' value={count} onChange={(e) => setCount(e.target.value)} />
									<button className='p-1 h-6 flex justify-center items-center w-6  border-2 border-gray-600 rounded-full text-center' onClick={() => setCount(count - 1)}>
										-
									</button>
								</div> */}
							</div>
							<div className='flex flex-col sm:flex-row  justify-end w-full'>
								<div className='p-2 space-y-3 ml-5 w-full'>
									<p>{name}</p>
									<p className='text-sm text-gray-400'>Seller: TREASURE HAUL ONLINE</p>
									<p>
										&#8377;{price}
										<span className='text-gray-400 line-through ml-3'>₹54,900</span>
										<span className='text-custom-green ml-2'>5% Off</span>
									</p>
								</div>
								<div className=' sm:block  justify-self-end sm:w-1/2  text-center sm:text-right'>
									<p>
										Delivery by Thu Sep 2 | <span className='text-custom-green mr-2'>Free</span>
										<span className='line-through'>₹40</span>
									</p>
									<p className='text-sm text-gray-400 my-2'>7 Days Replacement Policy</p>
									<div className='text-right'>
										<label htmlFor='total'>Total:</label>
										<input type='text' disabled value={`₹ ${price}`} className='border-2 border-gray-600 w-20 text-center ml-2 rounded' />
									</div>
									<div className='text-right'>
										<button className='bg-red-600 mt-5 py-2 px-4 rounded text-white ' onClick={() => removeItem(element)}>
											remove
										</button>
									</div>
								</div>
							</div>
						</div>
					);
				})}
				{cart.length ? <BuyNow setLength={setLength} /> : null}
			</section>
			{cart.length ? <OrderTotal totalprice={totalprice} length={length} /> : null}
		</div>
	);
};

export default Cart;
